import {
  CartServiceInterface,
  CheckEmailAnalyticsInterface,
  GetCheckEmailAnalyticsServiceOptions,
  HamletClientInterface
} from '../../model/check-email-page';
import { CheckEmailAnalytics } from './analytics';
import { CartService } from './cart-service';
import { HamletClient } from './mini-hamlet-client';

export * from './analytics';
export * from './cart-service';
export * from './mini-hamlet-client';

let hamletClient: HamletClientInterface;
let cartService: CartServiceInterface;
let checkEmailAnalytics: CheckEmailAnalyticsInterface;

export function getCheckEmailAnalyticsService({
  baseUrl,
  analyticsTrack,
  productKeys,
  googleAnalyticsId
}: GetCheckEmailAnalyticsServiceOptions) {
  if (!checkEmailAnalytics) {
    hamletClient = new HamletClient({ baseUrl });
    cartService = new CartService({ productKeys, hamletClient });
    checkEmailAnalytics = new CheckEmailAnalytics({
      analyticsTrack,
      googleAnalyticsId,
      cartService
    });
  }
  return checkEmailAnalytics;
}
